import "core-js/modules/es.array.push.js";
import Banner from '@/components/Banner2';
import { checkToken } from '@/api/modules/login.js';
import { getInfo } from '@/api/modules/personal';
import { mapMutations } from 'vuex';
export default {
  components: {
    Banner
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setHasLogin: 'user/setHasLogin',
      setUserInfo: 'user/setUserInfo',
      setUseProduct: 'user/setUseProduct'
    })
  },
  watch: {
    $route: {
      handler(n) {
        var _n$query;
        if ((_n$query = n.query) !== null && _n$query !== void 0 && _n$query.access_token) {
          var _n$query2;
          checkToken({
            access_token: ((_n$query2 = n.query) === null || _n$query2 === void 0 ? void 0 : _n$query2.access_token) || ''
          }).then(res => {
            if (res.code === 1) {
              // this.$router.push('/login')
              localStorage.setItem('access_token', res.result.access_token);
              getInfo().then(res => {
                if (res.code === 1) {
                  const {
                    result
                  } = res;
                  // console.log(result,'pppp');
                  this.setUseProduct(result.presentation_permissions);
                  this.setUserInfo({
                    customer_name: result.username
                  });
                  this.setHasLogin(true);
                  this.$router.push('/service/details');
                }
              });
            } else {
              this.setUserInfo({
                customer_name: ''
              });
              this.setHasLogin(false);
              this.$router.push('/login');
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
};